var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:"despatch-order-list",attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"setLoading":_vm.setLoading,"persistenceKey":'despatch-order-list',"gcPopupConfig":_vm.gcPopupConfig,"gcSOPayNowPopupConfig":_vm.gcSOPayNowPopupConfig,"gcSOPartPickPopupConfig":_vm.gcSOPartPickPopupConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }